import * as url from "../url_helper";

import { post } from "../api_helper";

export const addPromotion = data => post(url.ADD_NEW_PROMOTION, data);
export const getPromotion = data => post(url.GET_PROMOTION, data);
export const getPromotionList = data => post(url.GET_PROMOTION_LIST, data);
export const editPromotion = data => post(url.UPDATE_PROMOTION, data);
export const deletePromotion = data => post(url.DELETE_PROMOTION, data);
